import React from 'react';
import { Texture, TextStyle } from 'pixi.js'
import { Sprite, Container, AnimatedSprite, Text } from '@inlet/react-pixi'

const domElement = document.querySelector('#root');
let initWidth = domElement.offsetWidth;
let initHeight = domElement.offsetHeight;

const AlertBoxAnimationModal = ({ _isOpen, _notiCloseClick, _textures, _text }) => {
    if (initWidth < 2000) {
        initWidth = 1920;
        initHeight = 900;
    }
    let boxInitX = (initWidth - 560) / 2;
    let boxInitY = (initHeight - 250) / 2;

    const titleStyle2 = new TextStyle({
        fontFamily: '"Source Sans Pro", Helvetica, sans-serif',
        fontSize: 20,
        fill: "black",
        wordWrap: true,
        wordWrapWidth: 250,
        align: "center",

    });
    let alertTexture = Texture.from(`./assets/images/components/island/particle/alert_box.png`);
    let transparentTexture = Texture.from(`./assets/images/components/island/particle/transparentBG.png`);
    let awesomeBtn = Texture.from(`./assets/images/components/island/particle/awesome.png`);

    return (
        <>
            {
                _isOpen ?
                    <>
                        <Container>
                            <Sprite width={initWidth} height={initHeight} texture={transparentTexture} interactive={true} />
                        </Container>
                        <Container x={boxInitX} y={boxInitY}>
                            <Sprite
                                texture={alertTexture}
                            />
                            <AnimatedSprite
                                scale={{ x: 0.5, y: 0.5 }}
                                x={280}
                                y={5}
                                isPlaying={true}
                                animationSpeed={0.1}
                                textures={_textures}
                            />
                            <Text
                                text={_text}
                                x={170}
                                y={105}
                                style={titleStyle2}
                            />
                            <Sprite
                                texture={awesomeBtn}
                                x={200}
                                y={155}
                                interactive={true} buttonMode={true}
                                pointerdown={() => {
                                   _notiCloseClick()
                                }}
                            />
                        </Container>
                    </>
                    :
                    <></>
            }          
        </>
    );
}

export { AlertBoxAnimationModal as default }